__turbopack_context__.v({
  "container": "UegEzG_container",
  "count--1": "UegEzG_count--1",
  "count--2": "UegEzG_count--2",
  "inner": "UegEzG_inner",
  "item": "UegEzG_item",
  "size--sm": "UegEzG_size--sm",
});
